var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.342,
    height: 15.29,
    viewBox: "0 0 24.342 15.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9219",
    "data-name": "Group 9219",
    transform: "translate(-1814.053 -270.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5293",
    "data-name": "Path 5293",
    d: "M1835.68,275.231l-1.132.609a11.281,11.281,0,0,1,1.736,2.417.244.244,0,0,1,0,.282v.006a11.318,11.318,0,0,1-15.285,4.583l-1.158.623a13.087,13.087,0,0,0,8.735,1.517,12.953,12.953,0,0,0,9.329-6.7.288.288,0,0,0,0-.323A13.1,13.1,0,0,0,1835.68,275.231Z",
    fill: "#0A1C2D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5294",
    "data-name": "Path 5294",
    d: "M1838.272,270.7a1,1,0,0,0-1.356-.4l-4.535,2.489a13.091,13.091,0,0,0-5.858-1.487c-.643.043-1.1.061-1.57.106a10.241,10.241,0,0,0-1.073.161,13.019,13.019,0,0,0-9.12,6.689.269.269,0,0,0,0,.3,12.722,12.722,0,0,0,2.044,2.783l-2.23,1.224a1,1,0,0,0,.959,1.755l22.342-12.266A1,1,0,0,0,1838.272,270.7Zm-21.892,7.831a.226.226,0,0,1,0-.254,11.2,11.2,0,0,1,7.847-5.759,8.659,8.659,0,0,1,.923-.139c.4-.039.8-.054,1.35-.091a11.133,11.133,0,0,1,4.719,1.142l-2.838,1.558a3.915,3.915,0,0,0-2.048-.58h0a3.979,3.979,0,0,0-3.988,3.894l-4.393,2.412A10.669,10.669,0,0,1,1816.38,278.527Zm10.194-2.551-2.421,1.329A2.428,2.428,0,0,1,1826.574,275.976Z",
    fill: "#0A1C2D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5295",
    "data-name": "Path 5295",
    d: "M1830.323,278.435h0l-6.16,3.313a3.981,3.981,0,0,0,6.16-3.312Z",
    fill: "#0A1C2D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedEye);
export default __webpack_public_path__ + "static/media/closedEye.35de26d9.svg";
export { ForwardRef as ReactComponent };